module.exports = __webpack_public_path__ + "static/media/HomeGTBank.546bf0f5.svg";